import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Catalogo.css';

const Breadcrumbs = ({ items }) => (
  <nav className="seo-breadcrumbs" aria-label="Trilha de navegação">
    <ol>
      {items.map((item, index) => (
        <li key={item.path} aria-current={index === items.length - 1 ? 'page' : undefined}>
          {index === items.length - 1 ? item.name : <Link to={item.path}>{item.name}</Link>}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumbs;
